var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs,"divider":"/"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{attrs:{"disabled":item.disabled,"href":item.href}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }